<template>
  <div class="d-flex flex-column">
    <div class="mb-2">
      <b-button
        variant="bg-white"
        class="shadow"
        @click="$emit('close')"
      >
        <GjIcon name="ArrowLeft" />
        {{ groupName }}
      </b-button>
    </div>
    <paper
      :title="output.name"
      body-class="mt-0"
    >
      <div class="px-2 pb-1 text-break">
        <b-row>
          <b-col
            v-if="isHLS || isDash"
            cols="12"
            sm="6"
          >
            <input-field
              name="file_group-output_name"
              label="Folder name"
              label-position="top"
              :info="templateInfo.outputFolderName"
              info-position="label"
              @openInfo="openInfo"
            >
              <div>
                {{ output.name || '-' }}
              </div>
            </input-field>
          </b-col>
          <b-col
            cols="12"
            sm="6"
          >
            <input-field
              name="file_group-output_name_modifier"
              label="File name"
              label-position="top"
              :info="templateInfo.outputNameModifier"
              info-position="label"
              @openInfo="openInfo"
            >
              <div>
                {{ output.nameModifier || '-' }}
              </div>
            </input-field>
          </b-col>
          <b-col
            cols="12"
            sm="6"
          >
            <input-field
              name="file_group-output_preset-"
              label="Preset *"
              label-position="top"
              :info="templateInfo.outputPreset"
              info-position="label"
              @openInfo="openInfo"
            >
              <div v-if="output.presetId">
                {{ output.presetName || '-' }}
              </div>
            </input-field>
          </b-col>
        </b-row>
      </div>
    </paper>
  </div>
</template>

<script>
import InputField from '@/components/form/InputField.vue'
import Paper from '@/components/paper/Paper.vue'
import templateInfo from '../../settings/templateInfo'

export default {
  name: 'SingleOutputSettings',
  components: {
    Paper,
    InputField,
  },
  props: {
    output: {
      type: Object,
      default: null,
    },
    groupName: {
      type: String,
      default: null,
    },
    groupType: {
      type: Number,
      default: null,
    },
    isHLS: {
      type: Boolean,
      required: true,
    },
    isDash: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      templateInfo,
      outputPresetsModal: false,
      selectedPreset: null,
    }
  },
  methods: {
    openInfo(e) {
      this.$emit('openInfo', e)
    },
  },
}
</script>

<style scoped>
.staticPresetNameHeight {
  width: 100%;
}
</style>
